import moment from 'moment';

export const getHostingRenewalStatus = (
  expiryDate: string,
  format: string = 'MM/DD/YYYY',
) => {
  const today = moment().startOf('day');
  const expDate = moment(expiryDate, format, true);
  const ttl = moment.duration(expDate.diff(today)).asDays();

  const status = {
    isExpired: ttl <= 0,
    willExpireSoon: ttl > 0 && ttl <= 14,
    willExpire: ttl <= 45,
    willExpireLater: ttl > 45,
    willExpireInDays: Math.ceil(ttl),
  };

  return status;
};

export const getRenewalTooltipStatus = (
  hasAutoRenew: boolean,
  isExpired: boolean,
) => {
  if (hasAutoRenew && !isExpired) return 'isAutoRenewing';
  if (!hasAutoRenew && !isExpired) return 'renewDateWarning';
  if (isExpired) return 'renewDateExpired';
};

export const getRenewalIconColor = (
  hasAutoRenew: boolean,
  isExpired: boolean,
  willExpireLater: boolean,
) => {
  if ((hasAutoRenew && !isExpired) || (!hasAutoRenew && willExpireLater)) {
    return 'success';
  }
  return 'error';
};

export const getRenewalDateText = (
  hasAutoRenew: boolean,
  isExpired: boolean,
) => {
  if (hasAutoRenew && !isExpired) return 'isRenewing';
  if (!hasAutoRenew && !isExpired) return 'isExpiring';
  return 'isExpired';
};
